export const MENTOR_MENU_ITEMS = {
  ROSTER: {
    id: 'roster',
    label: 'Roster',
  },
  CLINICS: {
    id: 'clinics',
    label: 'Clinics',
    // icon: getImageLink('therapist'),
    // onClick: (id) => navigate(`/support/therapists/${id}`),
  },
  CALENDAR: {
    id: 'calendar',
    label: 'Calendar',
  },
  EVENTS: {
    id: 'events',
    label: 'Events',
  },
  ENGAGEMENT_MODELS: {
    id: 'engagement-models',
    label: 'Engagement Models',
  },
  PAYOUT_REPORTS: {
    id: 'payout-reports',
    label: 'Payout Reports',
  },
  NEXT_VISITS: {
    id: 'next-visits',
    label: 'Scheduled Visits',
  },
  EMR_SETTINGS: {
    id: 'emr-settings',
    label: 'EMR Settings',
  },
  PAYOUT_RECEIPTS: {
    id: 'payout-receipts',
    label: 'Payout Receipts',
  },
  PRESCRIPTION_TEMPLATES: {
    id: 'prescription-templates',
    label: 'Prescription Templates',
  },
  APPOINTMENTS: {
    id: 'appointments',
    label: 'Appointments',
  },
  INTERVENTIONS: {
    id: 'interventions',
    label: 'Interventions Requested',
  },
  AUDIT_REQUESTS: {
    id: 'audit-requests',
    label: 'Audit Requests',
  },
  PATIENTS: {
    id: 'patients',
    label: 'Patients',
  },
}

export const MENTOR_MENU_ITEMS_LIST = [
  MENTOR_MENU_ITEMS.CLINICS,
  MENTOR_MENU_ITEMS.CALENDAR,
  MENTOR_MENU_ITEMS.EVENTS,
  MENTOR_MENU_ITEMS.ENGAGEMENT_MODELS,
  MENTOR_MENU_ITEMS.PAYOUT_REPORTS,
  MENTOR_MENU_ITEMS.PAYOUT_RECEIPTS,
  MENTOR_MENU_ITEMS.NEXT_VISITS,
]
